// extracted by mini-css-extract-plugin
export default {"button":"RectButtonText_button__KjXAX","animation-opacity":"RectButtonText_animation-opacity__SgKP6"};